import { Controller } from "stimulus"

// [圖3] 的決策 popup。「建立新帳號」是整條流程唯一不可逆的一步（解綁只能走後台），
// 所以刻意不提供 ESC / 點背景關閉 —— 誤關會讓用戶停在一個沒有前因說明的畫面上。
export default class extends Controller {
  static targets = ["dialog"]

  connect() {
    this.blockEscape = this.blockEscape.bind(this)
    document.addEventListener("keydown", this.blockEscape)
  }

  disconnect() {
    document.removeEventListener("keydown", this.blockEscape)
  }

  blockEscape(event) {
    if (event.key === "Escape" && this.hasDialogTarget && !this.dialogTarget.classList.contains("hidden")) {
      event.preventDefault()
      event.stopPropagation()
    }
  }

  chooseLink(event) {
    event.preventDefault()
    this.dialogTarget.classList.add("hidden")
  }
}
